import { EnhanceStatus, LoadStatus } from './types';

export const fieldInitial = Object.freeze({
  status: EnhanceStatus.IDLE,
  logID: null,
  enhancedText: '',
  originalText: '',
  error: null,
});

export const usageInitial = Object.freeze({
  enabled: false,
  enhancementMonthlyTokenLimit: 0,
  monthlyTokensUsed: 0,
  monthlyTokensRemaining: 0,
  enhancementCount: 0,
  avgTokensPerRequest: 0,
  topUserName: null,
  topUserEnhancementCount: 0,
});

export default Object.freeze({
  enhancements: {},
  usage: usageInitial,
  usageStatus: LoadStatus.IDLE,
  settingsStatus: LoadStatus.IDLE,
  settingsSaving: false,
});
